import { getApiBaseUrl } from '../../utils/apiConfig';

const API_BASE_URL = getApiBaseUrl();

/**
 * @param {{ mode: 'me' | 'user', userId?: number|string, limit?: number }} opts
 */
export async function fetchAuthHistory({ mode = 'me', userId, limit = 50 } = {}) {
  const token = localStorage.getItem('authToken');
  if (!token) throw new Error('Não autenticado');

  const path =
    mode === 'user' && userId != null
      ? `/api/users/${encodeURIComponent(userId)}/auth-history`
      : '/api/users/me/auth-history';

  const qs = limit ? `?limit=${encodeURIComponent(limit)}` : '';
  const res = await fetch(`${API_BASE_URL}${path}${qs}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) {
    throw new Error(data.message || 'Erro ao carregar histórico');
  }
  return Array.isArray(data.data) ? data.data : [];
}
